<template>
  <div>
    <div class="table-header row">
      <div>
        <input
          type="checkbox"
          v-model="isSelectAll"
          @change="selectAllChange"
        />
      </div>
      <div>
        网吧名称/网吧ID
      </div>
      <div>
        所在分组
      </div>
      <div>
        外网IP
      </div>
      <div>服务器</div>
      <div>客户机</div>
      <div>路由器</div>
      <div>授权验证端口</div>
      <div>远程代理端口</div>
      <div>操作</div>
    </div>
    <div class="table-body">
      <div
        class="row"
        @click="toBar(item)"
        v-for="(item, index) in cacheTableList"
        :key="index"
      >
        <!-- 选中 -->
        <div>
          <input
            type="checkbox"
            @click.stop
            v-model="item.select"
            @change="selectChange(item.select)"
          />
        </div>
        <!-- 网吧名以及id -->
        <div class="bar-name">
          <p v-text="item.barName"></p>
          <p v-text="item.barId"></p>
        </div>
        <!-- 网吧分组名 -->
        <div>
          <span v-text="item.groupName"></span>
        </div>
        <!-- 外网ip -->
        <div>
          <span v-text="$PropFn.safeDislayValue(item.wanIp)"></span>
        </div>
        <!-- 服务器 -->
        <div class="server">
          <div :class="{
                            online: item.bsOnlineCnt > 0,
                            offline: item.bsOnlineCnt == 0
                        }">
            <!-- 在线的icon -->
            <img
              src=@/assets/img/icon/u422.png
              v-show="item.bsOnlineCnt>0"
            />
            <!-- 离线的icon -->
            <img
              src=@/assets/img/icon/u424.png
              v-show="item.bsOnlineCnt==0"
            />
            <span>
              在线
            </span>
            <span v-text="item.bsOnlineCnt"></span>
            <span>/</span>
            <span v-text="item.totalBsCnt"></span>
          </div>
        </div>
        <!-- 客户机在线数/总数 -->
        <div>
          <span v-text="item.bcOnline"></span>
          <span>/</span>
          <span v-text="item.bcSum"></span>
        </div>
        <!-- 路由器总数 -->
        <div>
          <span v-text="item.routerCnt"></span>
        </div>
        <!-- 授权验证端口 -->
        <div>
          <span
            :class="{ 'gray-word': !$PropFn.hasValue(item.vport) }"
            v-text="$PropFn.safeDislayValue(item.vport, '未设置')"
          ></span>
        </div>
        <!-- 远程代理端口 -->
        <div>
          <span
            :class="{ 'gray-word': !$PropFn.hasValue(item.pport) }"
            v-text="$PropFn.safeDislayValue(item.pport, '未设置')"
          ></span>
        </div>
        <div class="operate">
          <a
            href="#"
            v-show="hasRemote"
            @click.prevent.stop="toBar(item)"
          >远程</a>
          <a
            href="#"
            v-if="hasRemote"
            @click.prevent.stop="getAssistCode(item)"
          >设置远程授权</a>
          <word-down
            @click.stop
            :content="'更多'"
          >
            <div slot="down">
              <div v-show="hasEditBar">
                <div
                  class="drop-row"
                  @click.prevent.stop="editBarInfo(item)"
                >
                  <span>修改网吧信息</span>
                </div>
                <div
                  class="drop-row"
                  @click.prevent.stop="editBarPwd(item)"
                >
                  <span>修改网吧密码</span>
                </div>
                <i class="line"></i>
              </div>
              <div
                class="drop-row"
                @click.prevent.stop="addRouter(item)"
              >
                <span>添加路由远程</span>
              </div>
            </div>
          </word-down>
        </div>
      </div>
      <no-data
        style="height:auto;padding-top:20px;padding-bottom:20px;"
        v-show="tableList.length == 0 || loading"
        :nodata="tableList.length == 0 && !loading"
        :loading="loading"
      ></no-data>
    </div>
    <div
      class="table-pagination"
      v-show="tableList.length > 0"
    >
      <div style="float:left;padding-left:10px;">
        <input
          type="checkbox"
          v-model="isSelectAll"
          @change="selectAllChange"
        />
        <a
          href="#"
          style="margin-left:10px;"
          @click.prevent="barMoveTo"
          class="default-btn"
        >移动网吧到...</a>
        <div
          class="default-btn"
          style="margin-left:10px;cursor: pointer;"
          @click.prevent="addAllRouterRemote"
        >
          <span>批量添加路由</span>
        </div>
        <div
          class="default-btn"
          style="margin-left:10px;cursor: pointer;"
          @click.prevent="deleteAllRouter"
        >
          <span>批量删除路由</span>
        </div>
        <div
          class="default-btn"
          style="margin-left:10px;cursor: pointer;"
          @click.prevent="senBar"
        >
          <span>批量转移网吧</span>
        </div>
      </div>
      <page-component
        :total="total"
        :current-page="page"
        @pagechange="pagechange"
      ></page-component>
    </div>
  </div>
</template>

<script>
// 更多悬浮
import WordDown from "_c/dropdown/wordDown";
// 分页功能
import PageComponent from "_c/pagination/pageComponent";
import NoData from "_c/noData/noData";
import { mapState } from "vuex";

export default {
  name: "tableData",
  components: {
    WordDown,
    PageComponent,
    NoData
  },
  props: {
    tableList: {
      type: Array,
      default() {
        return [];
      }
    },
    total: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSelectAll: false,
      cacheTableList: []
    };
  },
  computed: {
    /* eslint-disable */
    ...mapState({
      hasEditBar: state => state.user.userInfo.hasEditBar,
      hasRemote: state => state => state.user.userInfo.hasRemote
    })
  },
  watch: {
    tableList() {
      this.isSelectAll = false;
      this.cacheTableList = this.tableList.map(item => {
        item.select = false;
        return item;
      });
    }
  },
  methods: {
    selectedBarIds() {
      let arr = [];
      this.cacheTableList.forEach(item => {
        if (item.select) {
          arr.push(item.barId);
        }
      });
      return arr;
    },
    pagechange(page) {
      this.$emit("pagechange", page);
    },
    selectAllChange() {
      if (this.isSelectAll) {
        this.cacheTableList.forEach(item => {
          item.select = true;
        });
      } else {
        this.cacheTableList.forEach(item => {
          item.select = false;
        });
      }
    },
    selectChange(selectState) {
      if (selectState) {
        // 对单项进行选中
        // 判断是否全部选中
        let selectAllState = this.cacheTableList.every(item => {
          return item.select == true;
        });
        // 若全部选中,则为全选状态
        if (selectAllState) {
          this.isSelectAll = true;
        }
      } else {
        // 对单项进行取消
        this.isSelectAll = false;
      }
    },
    toBar(item) {
      if (!this.hasRemote) {
        return false;
      }
      this.$router.push({
        path: `${this.$PAGE_API.home.children.barManager.children.index.children.barDetails.path}/${item.barId}`
      });
    },
    editBarInfo(data) {
      window.$modal.editBarInfo.show({ type: 1, barId: data.barId });
    },
    editBarPwd(data) {
      window.$modal.editBarInfo.show({ type: 2, barId: data.barId });
    },
    getAssistCode({ barId }) {
      window.$modal.assistCodeModal.show({ barId });
    },
    async barMoveTo() {
      if (this.selectedBarIds().length == 0) {
        return window.$msg({
          showClose: true,
          type: "error",
          message: "请选择选择网吧"
        });
      }
      let res = await window.$modal.barMoveToModal.show(
        this.selectedBarIds().join("|")
      );
      if (res) {
        this.$emit("refresh");
      }
    },
    addRouter({ barId }) {
      window.$modal.setRouterRemoteModal.show({ barId }, 0);
    },
    addAllRouterRemote() {
      this.$emit("addAllRouterRemote");
    },
    deleteAllRouter() {
      this.$emit("deleteAllRouter");
    },
    senBar() {
      this.$emit("senBar");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";

.row {
  width: 100%;
  cursor: pointer;
  @include clearfix();
  &:after {
    content: "";
    top: 0;
    left: 0;
    display: block;
    font-size: 0;
    height: 0;
    width: 0;
    clear: both;
    visibility: hidden;
  }
  > div {
    float: left;
    text-align: left;
    text-overflow: ellipsis;
    height: 50px;
    span {
      @include ellipsis();
      display: inline-block;
      max-width: 100%;
    }
    p {
      @include ellipsis();
      max-width: 100%;
    }
    a {
      text-align: left;
      text-indent: 0px;
      margin-right: 8px;
      color: #0066cc;
    }
    input {
      cursor: pointer;
    }
  }

  > div:nth-child(1) {
    width: 4%;
    text-indent: 10px;
    input {
      position: relative;
      top: 2px;
    }
  }
  > div:nth-child(2) {
    width: 14%;
  }
  > div:nth-child(3) {
    width: 10%;
  }
  > div:nth-child(4) {
    width: 10%;
  }
  > div:nth-child(5) {
    width: 10%;
  }
  > div:nth-child(6) {
    width: 6%;
  }
  > div:nth-child(7) {
    width: 6%;
  }
  > div:nth-child(8) {
    width: 8.8%;
  }
  > div:nth-child(9) {
    width: 8.8%;
  }
  > div:nth-child(10) {
    width: 22%;
  }
}

.table-header {
  > div {
    height: 30px;
    line-height: 30px;
  }
}

.bar-name {
  p {
    line-height: normal;
    line-height: 14px;
  }
  p:nth-child(1) {
    padding-top: 10px;
  }
}
.gray-word {
  color: $gray-word;
}
.server {
  .online {
    span {
      color: $green;
    }
  }
  .offline {
    span {
      color: $gray-word;
    }
  }
  img {
    position: relative;
    vertical-align: top;
    top: 18px;
    margin-right: 4px;
  }
}

.table-pagination {
  text-align: right;
  padding-right: 80px;
  padding-top: 20px;
  > div {
    display: inline-block;
  }
}
input[type="checkbox"] {
  cursor: pointer;
}
</style>
